var path = '/public-client/templates/breakout-selector.html';
var html = "<button class=\"btn btn-select\">\n\t<span class=\"icon icon-split-lg\"></span><span ng-show=\"vm.label\">{{vm.label}}</span>\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;